export * from "modules/landing/components/main/components/prom-cards-section/PromCardsSection";
